import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import './App.scss'
import store from './store'
import InitialData from './components/shared/InitialData'
import ContentStructure from './components/shared/ContentStructure'
import MainNavbar from './components/shared/MainNavbar'
import Footer from './components/shared/Footer'
import StageIndicator from './components/shared/StageIndicator'
import { getProgramIdentifier } from './utils'

const PersistRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isRestored, setIsRestored] = useState(false);

  // Persist the current route in localStorage whenever it changes
  useEffect(() => {
    if (isRestored) {
      // Store the full pathname (including basename) without any manipulation
      localStorage.setItem(`lastVisitedRoute_${getProgramIdentifier()}`, location.pathname);
    }
  }, [location, isRestored]);

  // Restore the route on the first load
  useEffect(() => {
    const savedRoute = localStorage.getItem(`lastVisitedRoute_${getProgramIdentifier()}`);
    
    if (savedRoute && !isRestored) {
      // Prevent an infinite loop by checking if we have already restored the route
      const currentPathname = location.pathname;
      
      // Only navigate if the saved route is different from the current route
      if (savedRoute !== currentPathname) {
        navigate(savedRoute, { replace: true });
      }
      
      setIsRestored(true);
    } else {
      setIsRestored(true); // If no saved route, mark as restored
    }
  }, [navigate, isRestored, location.pathname]);

  return null;
};


const RegistrationApp = () => {
  // Use the local instance if app gets used in development
  let baseUrl
  // @ts-ignore
  if (window._is_react_dev_server) {
    // @ts-ignore
    baseUrl = 'http://localhost:8000'
  } else {
    baseUrl = window.location.protocol + '//' + window.location.host
  }
  // Allow redirect to event details if id is given
  let event_id = ''
  const queryParams = new URLSearchParams(window.location.search)
  const participant_token = queryParams.get('token') || ''
  const last_pathname_entry: string =
    window.location.pathname.split('/').pop() || ''
  if (!isNaN(parseInt(last_pathname_entry))) {
    event_id = last_pathname_entry
  }

  const programId = window.location.pathname.split('/')[2]
  const isRestoredData = store.getState().misc.isRestoredData

  return (
    <Provider store={store}>
      <BrowserRouter basename={`anmeldung/${programId}`}>
        <Routes>
          <Route
            path={'/*'}
            element={
              <InitialData
                baseUrl={baseUrl}
                programId={parseInt(programId)}
                event_id={event_id}
                participant_token={participant_token}
                location={window.location}
                isRestoredData={isRestoredData}
              >
                <MainNavbar />
                <StageIndicator />
                <ContentStructure />
                <Footer />
              </InitialData>
            }>
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default RegistrationApp
